import http from '../plugins/axios'

export const getFaqList = async (params) => {
  try {
    const response = await http.get(`/api/v2/faq`, { params })
    return response.data
  } catch(error) {
    throw error
  }
}

export const addFaq = async (payload) => {
  try {
    const response = await http.post(`/api/v2/faq`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const updateFaq = async (faqId, payload) => {
  try {
    const response = await http.put(`/api/v2/faq/${faqId}`, payload)
    return response.data
  } catch(error) {
    throw error
  }
}

export const deleteFaq = async (faqId) => {
  try {
    const response = await http.delete(`/api/v2/faq/${faqId}`)
    return response.data
  } catch(error) {
    throw error
  }
}